import { render } from "./CriminalList.vue?vue&type=template&id=6b4a2a02&scoped=true"
import script from "./CriminalList.vue?vue&type=script&lang=js"
export * from "./CriminalList.vue?vue&type=script&lang=js"

import "./CriminalList.vue?vue&type=style&index=0&id=6b4a2a02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4a2a02"]])

export default __exports__